// apps/admin/src/hooks/useQueueMachine.ts

import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { QueueMachineWithRelations } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

/**
 * 獲取單一叫號機資訊的 Hook
 * @param queueMachineId 叫號機 ID
 * @returns 叫號機資訊、載入狀態和錯誤狀態
 */
export function useQueueMachine(queueMachineId: number | null | undefined) {
  const { token } = useAuth()

  // 只有在 queueMachineId 有效時才發送請求
  const enabled = !!queueMachineId && !!token

  const { data, isLoading, error, mutate } = useGet<ApiResponse<QueueMachineWithRelations>>(
    queueMachineId ? `/api/queue-machines/${queueMachineId}` : null,
    undefined, // 沒有查詢參數
    token, // 直接傳遞 token
    undefined, // 沒有 onUnauthorized 回調
    {
      // SWR 配置選項
      revalidateIfStale: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      // 只有在 queueMachineId 和 token 都存在時才啟用
      ...(enabled ? {} : { suspense: false }),
    },
  )

  return {
    queueMachine: data?.success ? data.data : null,
    isLoading,
    isError: !!error,
    error,
    mutate,
  }
}
